'use strict';

angular.module('shiftTraderApp')
  .controller('NotesShowCtrl', function ($scope, $location, note) {
    $scope.note = note;
    $scope.rel = lodash.filter($scope.note.notes_relations, { active: true })[0];

    function setButtonText() {
      if ($scope.rel.obj) {
        $scope.hideButton = false;
        if ($scope.rel.obj === 'Position') {
          $scope.buttonText = 'Take me to ' + $scope.rel.start_date.format('MMM DD');
        } else if ($scope.rel.obj === 'User') {
          $scope.buttonText = 'Take me to this User\'s Profile';
        } else if ($scope.rel.obj === 'WorkPeriod') {
          $scope.buttonText = 'Take me to this Shift';
        }
      }
    }

    setButtonText();

    $scope.goToObject = function() {
      if ($scope.rel.obj) {
        if ($scope.rel.obj === 'Position') {
          $location.path('/storeSchedule/' + $scope.rel.start_date.format('YYYY-MM-DD'));
        } else if ($scope.rel.obj === 'User') {
          $location.path('/profile/' + $scope.rel.obj_id);
        } else if ($scope.rel.obj === 'WorkPeriod') {
          $location.path('/storeSchedule/' + $scope.rel.start_date.format('YYYY-MM-DD'));
        }
      } else {
        $location.path('/storeSchedule/' + $scope.rel.start_date.format('YYYY-MM-DD'));
      }
    };
  });
